// 仿真任务 API 封装 / Simulations API facade
import { api, buildApiUrl } from "@/api/client";
import type { Mode, SimulationDetail, SimulationRow, SimulationStartRequest } from "@/lib/types";

export interface StartResponse {
  ok: true;
  simulation_id: string;
  status: string;
  events_url: string;
}

export interface RegenerateReportResponse {
  ok: true;
  report: {
    simulation_id: string;
    job_id: string;
    status: "pending";
  };
  simulation: SimulationRow;
}

export interface RegenerateGraphResponse {
  ok: true;
  graph: {
    simulation_id: string;
    base_prefix?: string;
    graph_keys?: Record<string, string>;
    l1?: Record<string, unknown>;
  };
  simulation: SimulationRow;
}

export const simulationsApi = {
  start: (body: SimulationStartRequest) =>
    api.post<StartResponse>("/api/v1/simulations", body),
  list: (mode?: Mode) =>
    api.get<{ ok: true; simulations: SimulationRow[] }>(
      mode ? `/api/v1/simulations?mode=${encodeURIComponent(mode)}` : "/api/v1/simulations",
    ),
  active: () =>
    api.get<{
      ok: true;
      simulation: SimulationRow | null;
      latest: SimulationRow | null;
    }>("/api/v1/simulations/active"),
  get: (id: string) =>
    api.get<{ ok: true; simulation: SimulationDetail }>(
      `/api/v1/simulations/${encodeURIComponent(id)}`,
    ),
  updateTitle: (id: string, title: string) =>
    api.patch<{ ok: true; title: string }>(`/api/v1/simulations/${encodeURIComponent(id)}`, {
      title,
    }),
  artifactUrl: (id: string, artifactName: string) =>
    buildApiUrl(
      `/api/v1/simulations/${encodeURIComponent(id)}/artifacts/${encodeURIComponent(artifactName)}`,
    ),
  cancel: (id: string) =>
    api.post<{ ok: true; cancel_requested?: true; cancelled?: boolean }>(
      `/api/v1/simulations/${encodeURIComponent(id)}/cancel`,
      {},
    ),
  regenerateReport: (id: string) =>
    api.post<RegenerateReportResponse>(
      `/api/v1/simulations/${encodeURIComponent(id)}/report/regenerate`,
      {},
    ),
  regenerateGraph: (id: string) =>
    api.post<RegenerateGraphResponse>(
      `/api/v1/simulations/${encodeURIComponent(id)}/graph/regenerate`,
      {},
    ),
  delete: (id: string) =>
    api.delete<{ ok: true; deleted: true }>(
      `/api/v1/simulations/${encodeURIComponent(id)}`,
    ),
};
